// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"ebdb3fd6","381":"5a317a11","545":"0566f14a","657":"ebdb3fd6"}[chunkId] + ".chunk.css";
};